export default __webpack_public_path__ + "static/media/keyvisual-rheinmaas.aa86da6c.jpg";